export class MathUtils {

  public static ratioToPercentage(n: number, fractionDigits = 0): number {
    /* Because of some unexpected results when multiplying a float by 100 e.g. 0.55 * 100  === 55.00000000000001 the below workaround is used */
    return parseFloat((n * 1000000 / 10000).toFixed(2));
  }

  // source: https://stackoverflow.com/questions/9539513/is-there-a-reliable-way-in-javascript-to-obtain-the-number-of-decimal-places-of/9539746#9539746
  public static countDecimals(n: number): number {
    // Make sure it is a number and use the builtin number -> string.
    const s = "" + (+n);
    // Pull out the fraction and the exponent.
    const match = /(?:\.(\d+))?(?:[eE]([+\-]?\d+))?$/.exec(s);
    // NaN or Infinity or integer.
    // We arbitrarily decide that Infinity is integral.
    if (!match) {
      return 0;
    }
    // Count the number of digits in the fraction and subtract the
    // exponent to simulate moving the decimal point left by exponent places.
    // 1.234e+2 has 1 fraction digit and '234'.length -  2 == 1
    // 1.234e-2 has 5 fraction digit and '234'.length - -2 == 5
    const fractionLength = match[1] == '0' ? 0 : (match[1] || '').length;
    const exponent = +(match[2] || 0);
    return Math.max(0, fractionLength - exponent);
  }

  public static percentageToHex(percentage: number): string {
    if (percentage < 0 || percentage > 100) {
      throw new Error('Percentage cannot be negative or larger than 100.');
    }
    const rgb = Math.round(percentage * 255 / 100);
    return rgb.toString(16).padStart(2, '0').toUpperCase();
  }

  public static isApproximatelyZero(value: number, ignoreAfterFractionDigits = 3): boolean {
    return Math.floor(Math.abs(value) * Math.pow(10, ignoreAfterFractionDigits)) === 0;
  }

  public static roundTo(value: number, decimalPlaces = 2): number {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

}
